export class Knight {
  static getMoves(position, color, gameState) {
    const [x, y] = position;
    const moves = [];
    
    // All L-shaped moves
    const knightMoves = [
      [2, 1], [2, -1], [-2, 1], [-2, -1],
      [1, 2], [1, -2], [-1, 2], [-1, -2]
    ];
    
    knightMoves.forEach(([dx, dy]) => {
      const newX = x + dx;
      const newY = y + dy;
      
      if (newX >= 1 && newX <= 8 && newY >= 1 && newY <= 8) {
        const targetPos = [newX, newY];
        
        if (!gameState.isOccupied(targetPos) || 
            gameState.getPieceColor(targetPos) !== color) {
          moves.push(targetPos);
        }
      }
    });
    
    return moves;
  }
}